export default __webpack_public_path__ + "static/media/smiley.9443e03b.svg";